<div class="dialog-header">
  <h2 mat-dialog-title>Указать исторические поставки</h2>
  <button mat-icon-button (click)="close()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="app-info">
    <p><strong>{{ 'historicalVolumesDialog.meatType' | translate }}:</strong> {{ getMeatTypeName(data.application.meatType) }}</p>
  </div>

  <form class="form-content">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Объем за первый год (тонн)</mat-label>
      <input matInput type="number" [(ngModel)]="volumeFirstYearTons" name="volumeFirstYearTons"
             step="0.001" min="0" required (ngModelChange)="calculateTotal()">
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Объем за 9 мес. пред. года (тонн)</mat-label>
      <input matInput type="number" [(ngModel)]="volumeNineMonthsPriorTons" name="volumeNineMonthsPriorTons"
             step="0.001" min="0" required (ngModelChange)="calculateTotal()">
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Общий объем импорта (тонн)</mat-label>
      <input matInput type="number" [ngModel]="totalImportVolumeTons" name="totalImportVolumeTons" readonly disabled>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Комментарий</mat-label>
      <textarea matInput [(ngModel)]="comment" name="comment" rows="3" maxlength="1000" required></textarea>
      <mat-hint align="end">{{ comment.length }}/1000</mat-hint>
    </mat-form-field>
  </form>

  @if (errorMessage()) {
    <div class="error-message">{{ errorMessage() }}</div>
  }
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="close()">Отмена</button>
  <button mat-raised-button color="primary"
          (click)="submit()"
          [disabled]="!isFormValid() || loading()">
    @if (loading()) {
      <mat-spinner diameter="20"></mat-spinner>
    } @else {
      Сохранить
    }
  </button>
</mat-dialog-actions>
